module.exports = __webpack_public_path__ + "img/380623a.jpg";